<template>
  <div :class="getClass()" :style="getStyle()">
    <div v-show="includeNumberOfResponses" class="form-inline pt-2" data-html2canvas-ignore="true" >
        <input type="checkbox" id="displayNumberOfResponses" name="displayNumberOfResponses" v-model="displayNumberOfResponses" @click="setShowNumberOfResponses($event)"/>
        <label for="segment" class="control-label pl-1">Show Respondents (n=)</label>
    </div>
    <div data-html2canvas-ignore="true" v-show="isVertical" class="caption">Click any entry to show/hide</div>
    <div class="chart-legend-key">
      <div class="element" v-for="(element, idxElements) in elements" v-bind:key="idxElements">
        <div @click="clickLegendSymbol($event, element)" :class="element.symbolClass" :style="getSymbolStyle(element)"></div>
        <div @click="clickLegendName($event, element)" class="name" v-html="element.name"></div>
      </div>
    </div>
    <div v-show="isHorizontal" class="caption">Click any entry to show/hide</div>
  </div>
</template>
<script>
import $ from "jquery";

import GoogleService from "../../services/google.service";
import SurveyService from "../../services/survey.service";
export default {
  name: "ChartLegend",
  mixins: [],
  components: {},
  data() {
    return {
      displayNumberOfResponses: false
    };
  },
  props: {
    containerId: {
      type: String,
      default: "chart-container"
    },
    showNumberOfResponses: {
      type: Boolean,
      default: false
    },
    includeNumberOfResponses: {
      type: Boolean,
      default: false
    },    
    location: {
      type: String,
      default: "default"
    },
    width: {
      type: String,
      default: "912px"
    },
    height: {
      type: String,
      default: "212px"
    },
    direction: {
      type: String,
      default: "horizontal"
    },
    elements: {
      type: Array,
      default: function() {
        return [
          {
            name: "",
            symbolClass: "",
            symbolColor: ""
          },
          {
            name: "",
            symbolClass: "",
            symbolColor: ""
          },
          {
            name: "",
            symbolClass: "",
            symbolColor: ""
          },
          {
            name: "",
            symbolClass: "",
            symbolColor: ""
          },
          {
            name: "",
            symbolClass: "",
            symbolColor: ""
          }
        ];
      }
    }
  },
  computed: {
    isVertical: function() {
      return this.direction == "vertical";
    },
    isHorizontal: function() {
      return this.direction == "horizontal";
    }
  },
  mounted() {
    let vm = this;
    this.$root.$on('check-number-of-responses', () => {
      vm.checkNumberOfResponses();
    });
  },
  created() {},
  methods: {
    setShowNumberOfResponses: function(e){
      this.$parent.setShowNumberOfResponses(e.target.checked);
    },
    checkNumberOfResponses: function(){
      let chartContainer = document.getElementById(this.containerId);
      if (chartContainer != null){
        let numberOfRecordsContainerList = chartContainer.querySelectorAll(".number-of-records");
        for (const numberOfRecordsContainer of numberOfRecordsContainerList) {
          if (numberOfRecordsContainer != null){
            if (this.showNumberOfResponses){
              numberOfRecordsContainer.style.display = "inline";
            } else {
              numberOfRecordsContainer.style.display = "none";
            }
          }
        }      
      }
    },
    clickLegendSymbol: function(event, element) {
      element.visible = !element.visible;
      var clickLegendSymbol = event.target;
      if (!element.visible) {
        clickLegendSymbol.parentElement.classList.add("lighter");
      } else {
        clickLegendSymbol.parentElement.classList.remove("lighter");
      }
      this.showOrHideElements(element);
    },
    clickLegendName: function(event, element) {
      element.visible = !element.visible;
      var clickLegendName = event.target;
      if (!element.visible) {
        clickLegendName.parentElement.classList.add("lighter");
      } else {
        clickLegendName.parentElement.classList.remove("lighter");
      }
      this.showOrHideElements(element);
    },
    showOrHideElements(element) {
      let category = this.location + " - " + SurveyService.getSurveyName();
      GoogleService.logClickEvent(category, "Legend",  0, this);

      this.$emit("redraw", element);
    },
    getStyle: function() {
      let style = "width: ";
      style += this.width;
      style += " ; ";
      style += "height: ";
      style += this.height;
      style += " ; ";
      return style;
    },
    getClass: function() {
      return "chart-legend " + this.direction;
    },
    getSymbolStyle: function(element) {
      if (this.containerId.includes("match") && element.symbolClass.includes("blueX")){
        return "color: " + element.symbolColor;    
      }
      return "background-color: " + element.symbolColor;
    }
  },
  watch: {
    showNumberOfResponses: function(){
      this.displayNumberOfResponses = this.showNumberOfResponses;
      this.checkNumberOfResponses();
    },
  }
};
</script>
